import React from 'react'
import classNames from 'classnames'
import './FileUploader.scss'
import { Link } from '../link/Link'

export const FileUploader = ({
  label,
  labelError,
  className,
  note,
  acceptedExtension,
  selectedFile,
  isLoading,
  isError,
  isDownloadEnabled,
  onSelectFileCallback,
  onClickResetCallback,
  onClickFileCallback,
  'data-mu-test': dataAttributeTest }) => {
  // const ref = useRef(null)

  const fileUploaderClasses = classNames(dataAttributeTest, 'file-upload')
  const containerClasses = classNames(className, '')

  function onFileChange (event) {
    onSelectFileCallback(event.target.files[0])
  }

  return (
    <div class={containerClasses}>

      <div className='row-flex m-bottom-0'>
        { !selectedFile
          ? <>
            <label class={fileUploaderClasses}>
              <input type='file' onChange={(event) => onFileChange(event)} accept={acceptedExtension} />
              {label}
            </label>

            </>
          : <>
            {isLoading ? <>
              <span className='is-loading p-right-thin' />
              <strong>{selectedFile}</strong>
            </>
              : <>
                <span className='icon-sli icon-paper-clip text-light p-right-thin' />
                {isDownloadEnabled
                  ? <Link className='textlink test-download-file' onClick={onClickFileCallback}>{selectedFile}</Link>
                  : <strong>{selectedFile}</strong>
                }
            </>}
            <button onClick={onClickResetCallback} class='file-upload_btn-delete button-reset' />
      </>}

      </div>
      {(isError) && <label className='input_is-required_text'>{labelError}</label>}
      <p className='text-light m-top-thin' >{note}</p>
    </div>
  )
}

FileUploader.defaultProps = {
}

FileUploader.propTypes = {
}
